export default {
  PLAN_RNTRC_PF: 2,
  PLAN_RNTRC_PJ: 3,
  PLAN_AUT: 22,
  PLAN_MAN: 21,
  PLAN_MAN_ECONOMICO:51,
  PLAN_AUT_ECONOMICO:52,
  PLAN_POS: 28,
  PLAN_PRE_SEM_TAXA: 30,
  PLAN_MAN_PJ: 31,
  PLAN_AUT_PJ: 32,
  PLAN_ROADCARD_PF: 70,
  PLAN_ROADCARD_PJ: 71,
  PLAN_MOVE_PAGUE: 33,
  PLAN_PREMEN_PF: 4,
  PLAN_PREMEN_PJ: 5,
  PLAN_PRE_MAN_CAM_PARANA_PF: 35,
  PLAN_PRE_AUT_CAM_PARANA_PF: 36,
  PLAN_PRE_MAN_CAM_PARANA_PJ: 37,
  PLAN_PRE_AUT_CAM_PARANA_PJ: 38,
  PLAN_PRE_AUT_MEN_SODRE_PF: 45,
  PLAN_PRE_AUT_MEN_SODRE_PJ: 55,
  PLAN_PRE_AUT_RODOSOL_PF: 62,
  PLAN_PRE_AUT_RODOSOL_PJ: 64,
  PLAN_EMBARCADOR_PJ: 6,
  RECHARGE_UNIT: 5000,
  RECHARGE_UNIT_ROADCARD_PF: 10000,
  RECHARGE_UNIT_ROADCARD_PJ: 25000,
  NEW_ADHESION_TAXID: 10,
  NEW_VEHICLE_TAXID: 67,
  GUARANTEE_TAXID: 12,
  LINK_RNTRC: 14,
  MONTHLY_TAX: 15,
  REPLACE_TAXID: 11,
  MSG_01_REPLACE_IN_HAND_SUCCESS: "Substituição e ativação realizadas com sucesso!",
  MSG_02_TAG_NOT_FOUND: "TAG não encontrada. Verifique o número e tente novamente.",
  // RECHARGE_UNIT_PJ_ESTRADEIRO: 50000,
  RECHARGE_UNIT_PJ: 50000,
  RECHARGE_UNIT_ECONOMICO: 2500,
  LIMIT_VEHICLES: -1,
  CAMINHOS_PARANA_CADASTRADO: 'CADASTRADO',
  ADHESION: 1,
  SALES_TYPE: {
    ADHESION: 1,
    RECHARGE: 2,
    ADHESIONVEHICLEADDITIONAL: 4,
    REPLACETAG: 6,
    GUARANTEE: 8
  },

  isPJ: function(planId){
    let self = this;
    switch(parseInt(planId)){
        case self.PLAN_PRE_MAN_CAM_PARANA_PF:
        case self.PLAN_PRE_AUT_CAM_PARANA_PF:
        case self.PLAN_MAN:
        case self.PLAN_AUT:
        case self.PLAN_PRE_SEM_TAXA:
        case self.PLAN_MOVE_PAGUE:
        case self.PLAN_ROTA_LIVRE:
        case self.PLAN_RNTRC_PF:
        case self.PLAN_PREMEN_PF:
        case self.PLAN_PRE_AUT_RODOSOL_PF:
          return false;
        break;
        case self.PLAN_PRE_MAN_CAM_PARANA_PJ:
        case self.PLAN_PRE_AUT_CAM_PARANA_PJ:
        case self.PLAN_MAN_PJ:
        case self.PLAN_AUT_PJ:
        case self.PLAN_POS:
        case self.PLAN_RNTRC_PJ:
        case self.PLAN_PREMEN_PJ:
        case self.PLAN_EMBARCADOR_PJ:
        case self.PLAN_PRE_AUT_RODOSOL_PJ:
        return true;
        break;

      }

  },

  Axes: [
    {
      value: 1,
      caption: "2 eixos, rodagem simples",
      category_artesp_id: 1,
      aut: true
    },
    {
      value: 2,
      caption: "2 eixos, rodagem dupla",
      category_artesp_id: 2,
      bus: true,
      truck: true
    },
    {
      value: 3,
      caption: "3 eixos, rodagem dupla",
      category_artesp_id: 3,
      bus: true,
      truck: true
    },
    {
      value: 4,
      caption: "4 eixos, rodagem dupla",
      category_artesp_id: 4,
      bus: true,
      truck: true
    },
    {
      value: 5,
      caption: "5 eixos, rodagem dupla",
      category_artesp_id: 5,
      truck: true
    },
    {
      value: 6,
      caption: "6 eixos, rodagem dupla",
      category_artesp_id: 6,
      truck: true
    },
    {
      value: 7,
      caption: "3 eixos, rodagem simples",
      category_artesp_id: 7,
      aut: true
    },
    {
      value: 8,
      caption: "4 eixos, rodagem simples",
      category_artesp_id: 8,
      aut: true
    },
    {
      value: 9,
      caption: "7 eixos, rodagem dupla",
      category_artesp_id: 61,
      truck: true
    },
    {
      value: 10,
      caption: "8 eixos, rodagem dupla",
      category_artesp_id: 62,
      truck: true
    },
    {
      value: 11,
      caption: "9 eixos, rodagem dupla",
      category_artesp_id: 63,
      truck: true
    },
    {
      value: 12,
      caption: "10 eixos, rodagem dupla",
      category_artesp_id: 64,
      truck: true
    },
    {
      value: 13,
      caption: "11 eixos, rodagem dupla",
      category_artesp_id: 65,
      truck: true
    },
    {
      value: 14,
      caption: "12 eixos, rodagem dupla",
      category_artesp_id: 66,
      truck: true
    },
    {
      value: 15,
      caption: "13 eixos, rodagem dupla",
      category_artesp_id: 67,
      truck: true
    },
    {
      value: 16,
      caption: "14 eixos, rodagem dupla",
      category_artesp_id: 68,
      truck: true
    },
    {
      value: 17,
      caption: "15 eixos, rodagem dupla",
      category_artesp_id: 69
    },
    {
      value: 18,
      caption: "16 eixos, rodagem dupla",
      category_artesp_id: 16,
      truck: true
    },
    {
      value: 19,
      caption: "17 eixos, rodagem dupla",
      category_artesp_id: 17,
      truck: true
    },
    {
      value: 20,
      caption: "18 eixos, rodagem dupla",
      category_artesp_id: 18,
      truck: true
    },
    {
      value: 21,
      caption: "19 eixos, rodagem dupla",
      category_artesp_id: 19,
      truck: true
    },
    {
      value: 22,
      caption: "20 eixos, rodagem dupla",
      category_artesp_id: 20,
      truck: true
    },
    {
      value: 23,
      caption: "21 eixos, rodagem dupla",
      category_artesp_id: 21,
      truck: true
    },
    {
      value: 24,
      caption: "22 eixos, rodagem dupla",
      category_artesp_id: 22,
      truck: true
    },
    {
      value: 25,
      caption: "23 eixos, rodagem dupla",
      category_artesp_id: 23,
      truck: true
    },
    {
      value: 26,
      caption: "24 eixos, rodagem dupla",
      category_artesp_id: 24,
      truck: true
    },
    {
      value: 27,
      caption: "25 eixos, rodagem dupla",
      category_artesp_id: 25,
      truck: true
    },
    {
      value: 28,
      caption: "26 eixos, rodagem dupla",
      category_artesp_id: 26,
      truck: true
    },
    {
      value: 29,
      caption: "27 eixos, rodagem dupla",
      category_artesp_id: 27,
      truck: true
    },
    {
      value: 30,
      caption: "28 eixos, rodagem dupla",
      category_artesp_id: 28,
      truck: true
    },
    {
      value: 31,
      caption: "29 eixos, rodagem dupla",
      category_artesp_id: 29,
      truck: true
    },
    {
      value: 32,
      caption: "30 eixos, rodagem dupla",
      category_artesp_id: 30,
      truck: true
    },
    {
      value: 33,
      caption: "31 eixos, rodagem dupla",
      category_artesp_id: 31,
      truck: true
    },
    {
      value: 34,
      caption: "32 eixos, rodagem dupla",
      category_artesp_id: 32,
      truck: true
    },
    {
      value: 35,
      caption: "33 eixos, rodagem dupla",
      category_artesp_id: 33,
      truck: true
    },
    {
      value: 36,
      caption: "34 eixos, rodagem dupla",
      category_artesp_id: 34,
      truck: true
    },
    {
      value: 37,
      caption: "35 eixos, rodagem dupla",
      category_artesp_id: 35,
      truck: true
    },
    {
      value: 38,
      caption: "36 eixos, rodagem dupla",
      category_artesp_id: 36,
      truck: true
    },
    {
      value: 39,
      caption: "37 eixos, rodagem dupla",
      category_artesp_id: 37,
      truck: true
    },
    {
      value: 40,
      caption: "38 eixos, rodagem dupla",
      category_artesp_id: 38,
      truck: true
    },
    {
      value: 41,
      caption: "39 eixos, rodagem dupla",
      category_artesp_id: 39,
      truck: true
    },
    {
      value: 42,
      caption: "40 eixos, rodagem dupla",
      category_artesp_id: 40,
      truck: true
    },
    {
      value: 43,
      caption: "41 eixos, rodagem dupla",
      category_artesp_id: 41,
      truck: true
    },
    {
      value: 44,
      caption: "42 eixos, rodagem dupla",
      category_artesp_id: 42,
      truck: true
    },
    {
      value: 45,
      caption: "43 eixos, rodagem dupla",
      category_artesp_id: 43,
      truck: true
    },
    {
      value: 46,
      caption: "44 eixos, rodagem dupla",
      category_artesp_id: 44,
      truck: true
    },
    {
      value: 47,
      caption: "45 eixos, rodagem dupla",
      category_artesp_id: 45,
      truck: true
    },
    {
      value: 48,
      caption: "46 eixos, rodagem dupla",
      category_artesp_id: 46,
      truck: true
    },
    {
      value: 49,
      caption: "47 eixos, rodagem dupla",
      category_artesp_id: 47,
      truck: true
    },
    {
      value: 50,
      caption: "48 eixos, rodagem dupla",
      category_artesp_id: 48,
      truck: true
    }
  ],

}




// WEBPACK FOOTER //
// ./src/pages/common/constantes.js